export const getHasOneTrustLoaded = () =>
  typeof window.OneTrust !== "undefined";
